export const teamSettingsSelector = state => state.entities.teamSettings;

export const teamAllowEasilTemplatesSettings = state => {
  const teamSettings = teamSettingsSelector(state);
  if (!teamSettings) {
    return false;
  }
  return teamSettings.allowEasilTemplates;
};
